angular.module('wbControllers').controller('TaxCalculatorController', ['$scope', 'tax', ($scope, tax) => {
  $scope.options = { income: 60000, province: 'BC', deductions: 6000 };
  $scope.results = {};

  function calculateCppEi(income) {
    // 2019 EI rate is 1.62% for each dollar of income between $0 and $53,100 to a maximum of $860.22
    let ei;
    const eiRate = 0.0162;

    if (income > 53100) {
      ei = 860.22; // max contribution
    } else {
      ei = income * eiRate;
    }

    // 2019 CPP rate is 5.1% for each dollar of income between $3,500 and $57,400. maximum annual contribution of $2,748.90
    const cppRate = 0.051;
    let cpp = 0;

    if (income >= 3500 && income <= 57400) {
      // need to subtract 3500 from income because the rate is applied on each dollar between the two amounts
      cpp = (income - 3500) * cppRate;
    } else if (income >= 57401) {
      cpp = 2748.90; // max contribution
    }

    return cpp + ei;
  }

  $scope.$watch('options',
    () => {
      $scope.results.federalTaxes = tax.getFederalTaxTable($scope.options.income - $scope.options.deductions);
      $scope.results.provincialTaxes = tax.getProvincialTaxTable($scope.options.income - $scope.options.deductions, $scope.options.province);
      $scope.results.totalFederalTax = _.sumBy($scope.results.federalTaxes, 'amount');
      $scope.results.totalProvincialTax = _.sumBy($scope.results.provincialTaxes, 'amount');

      $scope.results.totalTax = $scope.results.totalProvincialTax + $scope.results.totalFederalTax;
      $scope.results.taxSaved = tax.getTaxDeduction($scope.options.income, $scope.options.deductions, $scope.options.province);

      $scope.results.cppEi = calculateCppEi($scope.options.income);

      $scope.results.averageTaxRate = $scope.results.totalTax / ($scope.options.income - $scope.options.deductions);
    },
    true);
}]);
